import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
	name: 'default',
	leave({ current, next, trigger }) {
		return new Promise(resolve => {

			document.dispatchEvent(new CustomEvent('close-menu'));

			gsap.to(current.container, {
				opacity: 0,
				ease: 'none',
				duration: 1,
				onComplete: () => {
					resolve();
				},
			});

		});
	},
	afterLeave({ current, next, trigger }) {
		return new Promise(resolve => {

			document.dispatchEvent(new CustomEvent('disable-scroll'));

			gsap.set(next.container, {
				opacity: 0,
			});

			gsap.set(current.container, {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				zIndex: -10,
				onComplete: () => {
					resolve();
				}
			});

		});
	},
	beforeEnter({ current, next, trigger }) {
		return new Promise(resolve => {
			document.dispatchEvent(new CustomEvent('enable-scroll'));

			gsap.to(window, {
				duration: 0,
				scrollTo: {
					y: 0
				},
				onComplete: () =>  {
					gsap.to(window, {
						duration: 0,
						scrollTo: {
							y: 0
						},
					});
					resolve();
				}
			});

		});
	},
	after({ current, next, trigger }) {
		return new Promise(resolve => {

			ScrollTrigger.refresh();

			gsap.to(next.container, {
				opacity: 1,
				ease: 'none',
				duration: 1.5,
				onComplete: () => {
					resolve();
				},
			});

		});
	},
};
